export type ISidebarConfig = {
	route: string | { default: string; RBDM?: string };
	ariaLabel: string | { default: string; TSI?: string; IMR?: string; RBDM?: string };
	icon: string;
	key: string;
};

export const SidebarConfig: ISidebarConfig[] = [
	{
		key: 'end-users',
		route: { default: '/end-users', RBDM: '/rbdm/end-users/all' },
		ariaLabel: 'Members',
		icon: 'icon-users',
	},
	{
		key: 'supervisor',
		route: { default: '/supervisor', RBDM: '/rbdm/supervisor' },
		ariaLabel: 'Supervisor',
		icon: 'icon-users',
	},
	{
		key: 'factory-visit',
		route: '/factory-visit',
		ariaLabel: 'Factory Visit',
		icon: 'icon-factory',
	},
	{
		key: 'meetings',
		route: { default: '/meetings', RBDM: '/rbdm/meetings' },
		ariaLabel: { default: 'Meetings', TSI: 'One to Many' },
		icon: 'icon-coffee',
	},
	{
		key: 'mdp-planning',
		route: { default: '/meetings/mdp', RBDM: '/rbdm/meetings/mdp' },
		ariaLabel: { default: 'Assigned Meets', RBDM: 'MDP Planning' },
		icon: 'icon-goal',
	},
	{
		key: 'product-performance',
		route: '/product-performance',
		ariaLabel: 'Product Performance',
		icon: 'icon-star-bag',
	},
	{
		key: 'site-summary',
		route: { default: '/site-summary', RBDM: '/rbdm/site-summary' },
		ariaLabel: 'Site Leads',
		icon: 'icon-tool',
	},
	{
		key: 'dealer-visit-summary',
		route: '/dealer-visit-summary',
		ariaLabel: 'Dealer Visit',
		icon: 'icon-package',
	},
	{
		key: 'one-to-one-meeting-summary',
		route: '/one-to-one-meeting-summary',
		ariaLabel: 'One to One Meetings',
		icon: 'icon-star-calander',
	},
	{
		key: 'lms-users',
		route: '/lms/users',
		ariaLabel: 'Members',
		icon: 'icon-users',
	},
	{
		key: 'lms-my-tasklist',
		route: '/lms/my-tasklist',
		ariaLabel: 'My Tasklist',
		icon: 'icon-folded-paper',
	},
	{
		key: 'lms-sites',
		route: '/lms/sites',
		ariaLabel: 'Sites',
		icon: 'icon-tool',
	},
	{
		key: 'lms-map-view',
		route: '/lms/mapview',
		ariaLabel: 'Map View',
		icon: 'icon-star',
	},
	{
		key: 'gallery',
		route: '/gallery',
		ariaLabel: 'Gallery',
		icon: 'icon-gallery',
	},
	{
		key: 'field-marketing-content',
		route: '/field-marketing-content',
		ariaLabel: 'Field Marketing Content',
		icon: 'icon-gallery',
	},
	{
		key: 'structured-questionnaires',
		route: '/structured-questionnaires',
		ariaLabel: 'Structured Questionnaires',
		icon: 'icon-structured-questionnaire',
	},
	{
		key: 'pcms',
		route: '/pcms',
		ariaLabel: 'PCMS',
		icon: 'icon-tv',
	},
	{
		key: 'jharokha',
		route: '/jharokha',
		ariaLabel: 'Jharokha',
		icon: 'icon-tv',
	},
	{
		key: 'help-and-support',
		route: '/help-and-support',
		ariaLabel: 'Help & Support',
		icon: 'icon-help-circle',
	},
];
